export const colors = ['#EF6C00', '#A34A00', '#679F38', '#34691E',"#C13A5E","#7D263D",'#0099A5','#00717A','#016EAD','#184D93','#799199','#7C1EA4'];
